/* LLS Support Widget v2 (2026-09-10). Vanilla JS, no dependencies.
   Config: window.LLS_SUPPORT = { endpoint, greeting, hideTidio, tidioBridge, customer:{email,name,id}, supportEmail, logo, avatars:[{img,name}] } */
(function () {
  'use strict';
  var cfg = Object.assign({
    endpoint: '',
    supportEmail: 'help@llsupplements.co.uk',
    hideTidio: true,
    tidioBridge: true,
    customer: null,
    brand: 'Love Life Supplements',
    logo: 'https://www.lovelifesupplements.co.uk/cdn/shop/files/mobile2Asset_6.png?width=240',
    avatars: []   // optional [{img, name}] real team photos; falls back to a brand mark chip
  }, window.LLS_SUPPORT || {});
  if (!cfg.endpoint) return;

  // WhatsApp (27 Oct 2026): UK number on .co.uk, US number on .com. Same bot answers, a person takes over in Chatwoot.
  var WA_NUM = /lovelifesupplements\.com$/i.test(location.hostname) ? '16562233952' : '441223912347';
  // A chat already started carries its ref, so the bot and the team pick up the website chat on WhatsApp.
  function waUrl() {
    var ref = state && state.id && state.msgs && state.msgs.length ? state.id.slice(0, 8) : '';
    var text = ref ? 'Hi Love Life Supplements, carrying on from my chat on your website (ref ' + ref + '): ' : 'Hi Love Life Supplements, I have a question: ';
    return 'https://wa.me/' + WA_NUM + '?text=' + encodeURIComponent(text);
  }
  var STORE_KEY = 'lls_support_v1';
  var IDENT_KEY = 'lls_support_identity';
  // Testing: ?lls_reset=1 on any page wipes what this browser remembers (conversation, saved
  // identity, Klaviyo recognition) so the widget behaves like a brand-new visitor.
  if (/[?&]lls_reset=1/.test(location.search)) {
    try { localStorage.removeItem(STORE_KEY); localStorage.removeItem(IDENT_KEY); } catch (e) {}
    try { document.cookie = '__kla_id=; Max-Age=0; path=/'; } catch (e) {}
  }
  // The buy flow and answer pills went live for everyone on 11 September 2026, after being
  // built and reviewed on a dev theme. ?lls_labs=0 switches them off in a browser without a
  // deploy, which is the quickest way to pull them if anything needs stopping in a hurry.
  var LABS = true;
  try { if (/[?&]lls_labs=0/.test(location.search)) LABS = false; } catch (e) {}
  var state = load();
  var identity = loadIdentity();
  var view = 'home';

  function loadIdentity() {
    try { var i = JSON.parse(localStorage.getItem(IDENT_KEY) || 'null'); if (i && i.email && i.exp > Date.now()) return i; } catch (e) {}
    return null;
  }
  function saveIdentity(i) { identity = i; try { if (i) localStorage.setItem(IDENT_KEY, JSON.stringify(i)); else localStorage.removeItem(IDENT_KEY); } catch (e) {} }
  // Klaviyo identifies visitors who clicked an LLS email (or filled a form) and keeps an encrypted id in its first-party cookie.
  function klaviyoExchangeId() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!m) return '';
      var j = JSON.parse(atob(decodeURIComponent(m[1])));
      return j && j.$exchange_id ? String(j.$exchange_id).slice(0, 200) : '';
    } catch (e) { return ''; }
  }

  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (s && s.t && Date.now() - s.t < 24 * 3600 * 1000) return s;
    } catch (e) {}
    return { id: null, msgs: [], t: Date.now(), open: false };
  }
  function save() { try { state.t = state.t || Date.now(); localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {} }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function knownName() {
    var n = (cfg.customer && cfg.customer.name) || (identity && identity.name) || state.name || '';
    return String(n).trim().split(' ')[0];
  }
  function knownEmail() { return (cfg.customer && cfg.customer.email) || (identity && identity.email) || state.email || ''; }

  // ---------- SVG icons ----------
  var IC = {
    chat: '<svg class="lls-ic-chat" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5z"/></svg>',
    walaunch: '<svg class="lls-ic-chat" width="32" height="32" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.7.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3z"/></svg>',
    close: '<svg class="lls-ic-close" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    box: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8 12 3 3 8l9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></svg>',
    sub: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/><path d="M3 21v-5h5"/></svg>',
    spark: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2 2M16 16l2 2M18 6l-2 2M8 16l-2 2"/></svg>',
    agent: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21a8 8 0 1 0-16 0"/><circle cx="12" cy="7" r="4"/></svg>',
    chev: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>',
    wa: '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.7.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3z"/></svg>',
    home: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 10 9-7 9 7v9a2 2 0 0 1-2 2h-4v-6H9v6H5a2 2 0 0 1-2-2z"/></svg>',
    msg: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.4 8.4 0 0 1-8.5 8.5 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5 8.5 8.5 0 0 1 12.5 3 8.5 8.5 0 0 1 21 11.5z"/></svg>',
    truck: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v8H3z"/><path d="M14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg>',
    send: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2 11 13"/><path d="M22 2 15 22l-4-9-9-4z"/></svg>'
  };

  var MENU = [
    { ic: 'box',   t: 'Where is my order?',        s: 'Track a delivery or check dispatch', q: 'Where is my order?' },
    { ic: 'sub',   t: 'Manage a subscription',      s: 'Skip, reschedule, pause or resume',  q: 'I would like to change my subscription' },
    { ic: 'spark', t: 'Find the right product',     s: 'Tell us your goal and we will guide', q: 'Which product is right for me?' },
    { ic: 'truck', t: 'Delivery & returns',          s: 'Times, costs and the 60-day guarantee', q: 'What are your delivery times and what is your returns policy?' }
  ];

  function avatarsHtml() {
    if (cfg.avatars && cfg.avatars.length) {
      return '<div class="lls-sw-avatars">' + cfg.avatars.slice(0, 3).map(function (a) {
        return a.img ? '<img src="' + esc(a.img) + '" alt="' + esc(a.name || 'LLS team') + '">'
                     : '<span>' + esc((a.name || '?').charAt(0)) + '</span>';
      }).join('') + '</div>';
    }
    return '';
  }

  // ---------- DOM ----------
  var root = document.createElement('div');
  root.id = 'lls-support';
  root.innerHTML =
    // Ben 2 Nov 2026: the launcher wears the WhatsApp symbol to see if more people start a chat (WhatsApp first on the home panel).
    '<button type="button" class="lls-sw-bubble lls-sw-bubble-wa" aria-label="Chat with us on WhatsApp or here" aria-expanded="false">' + IC.walaunch + IC.close +
      '<span class="lls-sw-badge" hidden>1</span></button>' +
    '<section class="lls-sw-panel" role="dialog" aria-label="Love Life Supplements support" data-view="home" hidden>' +
      '<header class="lls-sw-head">' +
        '<div class="lls-sw-head-top">' +
          '<div class="lls-sw-brand">' +
            (cfg.logo ? '<img class="lls-sw-logo" src="' + esc(cfg.logo) + '" alt="' + esc(cfg.brand) + '" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'inline\'">' : '') +
            '<span class="lls-sw-wordmark"' + (cfg.logo ? ' style="display:none"' : '') + '>Love Life</span>' +
            avatarsHtml() +
          '</div>' +
          '<button type="button" class="lls-sw-close" aria-label="Close chat">&times;</button>' +
        '</div>' +
        '<div class="lls-sw-hero">' +
          '<h2 class="lls-sw-hero-h"></h2>' +
          '<p>Real people, real answers. Ask about your order, a subscription, or which supplement suits you.</p>' +
          '<span class="lls-sw-status"><span class="lls-sw-dot"></span>Typically replies in a few minutes</span>' +
        '</div>' +
      '</header>' +
      '<div class="lls-sw-body">' +
        '<div class="lls-sw-home">' +
          '<div class="lls-sw-card">' +
            '<div class="lls-sw-card-lead"><strong>How can we help?</strong><span>Ask anything, or pick a topic.</span></div>' +
            '<a class="lls-sw-wabtn lls-sw-wa" data-where="home" href="https://wa.me/' + WA_NUM + '" target="_blank" rel="noopener">' + IC.wa + ' Chat on WhatsApp</a>' +
            '<button type="button" class="lls-sw-cta">' + IC.send + ' Chat here</button>' +
            MENU.map(function (m) {
              return '<button type="button" class="lls-sw-row" ' + (m.human ? 'data-human="1"' : 'data-q="' + esc(m.q) + '" data-label="' + esc(m.t) + '"') + '>' +
                '<span class="lls-sw-row-ic">' + IC[m.ic] + '</span>' +
                '<span class="lls-sw-row-tx"><b>' + esc(m.t) + '</b><small>' + esc(m.s) + '</small></span>' +
                '<span class="lls-sw-row-ch">' + IC.chev + '</span></button>';
            }).join('') +
          '</div>' +
          '<p class="lls-sw-trust">Answers come from our own product pages and policies. For anything medical, a person takes over. <a href="mailto:' + esc(cfg.supportEmail) + '">' + esc(cfg.supportEmail) + '</a></p>' +
        '</div>' +
        '<div class="lls-sw-chat" hidden>' +
          '<p class="lls-sw-who" hidden></p>' +
          '<div class="lls-sw-msgs" aria-live="polite"></div>' +
          '<div class="lls-sw-quick">' +
            '<button type="button" data-q="Where is my order?">Where is my order?</button>' +
            '<button type="button" data-q="I would like to change my subscription">My subscription</button>' +
            '<button type="button" data-q="Which product is right for me?">Which product suits me?</button>' +
            '<button type="button" data-q="What are your delivery times and what is your returns policy?">Delivery &amp; returns</button>' +
          '</div>' +
          '<a class="lls-sw-waswitch lls-sw-wa" data-where="chat" href="https://wa.me/' + WA_NUM + '" target="_blank" rel="noopener">' + IC.wa + '<span>Switch to WhatsApp</span><small>keep chatting from your phone</small></a>' +
          '<form class="lls-sw-form">' +
            '<textarea rows="1" placeholder="Type your message" aria-label="Your message" maxlength="2000"></textarea>' +
            '<button type="submit" aria-label="Send">' + IC.send + '</button>' +
          '</form>' +
          '<p class="lls-sw-foot">For refunds or anything medical we hand you to a person. <a href="mailto:' + esc(cfg.supportEmail) + '">' + esc(cfg.supportEmail) + '</a></p>' +
        '</div>' +
      '</div>' +
      '<nav class="lls-sw-nav">' +
        '<button type="button" data-view="home" class="is-active">' + IC.home + 'Home</button>' +
        '<button type="button" data-view="chat">' + IC.msg + '<span>Messages</span><span class="lls-nav-badge" hidden>1</span></button>' +
      '</nav>' +
    '</section>';
  document.body.appendChild(root);

  var bubble = root.querySelector('.lls-sw-bubble');
  var badge = root.querySelector('.lls-sw-badge');
  var navBadge = root.querySelector('.lls-nav-badge');
  var panel = root.querySelector('.lls-sw-panel');
  var homeEl = root.querySelector('.lls-sw-home');
  var chatEl = root.querySelector('.lls-sw-chat');
  var heroH = root.querySelector('.lls-sw-hero-h');
  var msgs = root.querySelector('.lls-sw-msgs');
  var quick = root.querySelector('.lls-sw-quick');

  // What the customer is actually looking at, so the openers can be about that.
  function pageProduct() {
    if (!/\/products\//.test(location.pathname)) return '';
    var h = document.querySelector('h1');
    var t = (h && h.textContent || '').replace(/\s+/g, ' ').trim().replace(/\s*\(.*\)\s*$/, '');
    return t && t.length < 60 ? t : '';
  }
  function setQuickOpeners() {
    var prod = pageProduct();
    var opts = prod ? [
      ['How do I take ' + prod + '?', 'How do I take it?'],
      ['What is in ' + prod + '? List the ingredients.', 'What is in it?'],
      ['Is ' + prod + ' suitable for vegans?', 'Is it vegan?'],
      ['Is ' + prod + ' right for me?', 'Is it right for me?'],
    ] : [
      ['Where is my order?', 'Where is my order?'],
      ['I would like to change my subscription', 'My subscription'],
      ['Which product is right for me?', 'Which product suits me?'],
      ['What are your delivery times and what is your returns policy?', 'Delivery & returns'],
    ];
    quick.innerHTML = opts.map(function (o) {
      return '<button type="button" data-q="' + esc(o[0]) + '">' + esc(o[1]) + '</button>';
    }).join('');
  }
  setQuickOpeners();
  var form = root.querySelector('.lls-sw-form');
  var input = form.querySelector('textarea');
  var sendBtn = form.querySelector('button');
  var navBtns = root.querySelectorAll('.lls-sw-nav button');
  var busy = false;

  function render(text) {
    // The model is told not to use markdown; if a stray ** or heading slips through, show words, not symbols.
    text = String(text == null ? '' : text).replace(/\*\*([^*]+)\*\*/g, '$1').replace(/^#{1,4}\s+/gm, '').replace(/^\s*[-*]\s+/gm, '');
    return esc(text)
      .replace(/(https?:\/\/[^\s<]+[^\s<.,;:)!?])/g, function (u) { return '<a href="' + u + '" target="_blank" rel="noopener">' + u.replace(/^https?:\/\/(www\.)?/, '') + '</a>'; })
      .replace(/\n/g, '<br>');
  }
  function add(who, text, opts) {
    var el = document.createElement('div');
    el.className = 'lls-sw-msg lls-sw-' + who + (opts && opts.note ? ' lls-sw-note' : '');
    el.innerHTML = render(text);
    msgs.appendChild(el); msgs.scrollTop = msgs.scrollHeight;
    return el;
  }
  // Replaces the three dots with a short note ("Checking stock") while a lookup runs, so the
  // wait reads as work rather than as the thing having hung.
  function typingLabel(text) {
    typing(true);
    var t = msgs.querySelector('.lls-sw-typing');
    if (t) { t.classList.add('lls-sw-typing-lbl'); t.textContent = text + '\u2026'; }
  }
  function typing(on) {
    var t = msgs.querySelector('.lls-sw-typing');
    if (on && !t) { t = document.createElement('div'); t.className = 'lls-sw-msg lls-sw-bot lls-sw-typing'; t.innerHTML = '<span></span><span></span><span></span>'; msgs.appendChild(t); msgs.scrollTop = msgs.scrollHeight; }
    if (!on && t) t.remove();
  }
  function hideTidio() {
    if (!cfg.hideTidio) return;
    var api = window.tidioChatApi;
    if (api && api.hide) { try { api.hide(); } catch (e) {} }
    else document.addEventListener('tidioChat-ready', function () { try { window.tidioChatApi.hide(); } catch (e) {} });
  }

  function heroGreeting() {
    var n = knownName();
    heroH.textContent = n ? ('Hi ' + n + ' 👋') : 'Hi there 👋';
  }
  function greeting() {
    var n = knownName();
    return n ? ('Hi ' + n + ', what can we help with? Products, delivery, an order, your subscription or anything else, just ask.')
             : 'Hi, what can we help with today? Products, delivery, an order, your subscription or anything else, just ask.';
  }
  function updateWhoLine() {
    var el = root.querySelector('.lls-sw-who');
    if (!el) return;
    var email = knownEmail(), n = knownName();
    if (email) {
      el.innerHTML = 'Chatting as ' + (n ? '<b>' + esc(n) + '</b> ' : '') + esc(email) +
        (cfg.customer ? '' : ' <button type="button" class="lls-sw-notyou">Not you?</button>');
      el.hidden = false;
    } else { el.hidden = true; }
  }

  function ensureGreeting() {
    if (msgs.children.length) return;
    if (state.msgs.length) state.msgs.forEach(function (m) { if (m.who === 'agent') addAgent(m.sender, m.text); else add(m.who, m.text); });
    else add('bot', greeting());
    restorePills();
  }
  function restorePills() {
    if (!LABS || !state.pills || !state.pills.items || !state.pills.items.length) return;
    if (state.offer) { buyOffer = state.offer; buyVariant = state.offerVar || 0; }
    var p = state.pills;
    if (p.type === 'actions') renderActions(p.items); else renderSuggestions(p.items);
  }
  function setView(v) {
    if (!panel.hidden) dropNudge();
    view = v; panel.setAttribute('data-view', v);
    homeEl.hidden = v !== 'home'; chatEl.hidden = v !== 'chat';
    navBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-view') === v); });
    if (v === 'chat') { ensureGreeting(); quick.hidden = state.msgs.length > 0 || !!(state.live && state.live.on); navBadge.hidden = true; updateWhoLine(); setTimeout(function () { focusInput(false); }, 50); }
    state.view = v; save();
  }
  function dropNudge() { var n = document.querySelector('#lls-support .lls-sw-nudge'); if (n) n.remove(); }
  function openPanel() {
    dropNudge();
    panel.hidden = false; bubble.classList.add('is-open'); bubble.setAttribute('aria-expanded', 'true'); badge.hidden = true;
    state.open = true; save();
    heroGreeting();
    setView(state.msgs.length ? 'chat' : (state.view || 'home'));
  }
  function closePanel() { panel.hidden = true; bubble.classList.remove('is-open'); bubble.setAttribute('aria-expanded', 'false'); state.open = false; save(); bubble.focus(); }

  bubble.addEventListener('click', function () { panel.hidden ? openPanel() : closePanel(); });
  root.querySelector('.lls-sw-close').addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) closePanel(); });
  navBtns.forEach(function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-view')); }); });
  root.querySelector('.lls-sw-cta').addEventListener('click', function () { setView('chat'); });
  root.addEventListener('click', function (e) { var w = e.target.closest('.lls-sw-wa'); if (!w) return; w.href = waUrl(); track('wa_clicked', { where: w.getAttribute('data-where') || '' }); });
  homeEl.addEventListener('click', function (e) { var r = e.target.closest('.lls-sw-row'); if (!r) return; if (r.getAttribute('data-human')) { humanFlow(); return; } var q = r.getAttribute('data-q'); if (q) { setView('chat'); send(q, r.getAttribute('data-label')); } });
  quick.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; if (b.getAttribute('data-human')) { humanFlow(); return; } var q = b.getAttribute('data-q'); if (q) send(q, b.textContent); });
  root.addEventListener('click', function (e) {
    var act = e.target.closest('.lls-sw-act');
    if (act) {
      var a = act.getAttribute('data-act'), arg = act.getAttribute('data-arg');
      // Going to read the product page is a detour, not a decision: keep the row so it is
      // still there when they come back, instead of stranding them with no way to buy.
      if (a === 'details') { if (buyOffer && buyOffer.url) { track('details_clicked', { product: buyOffer.product }); say('me', 'See full details'); window.location.href = buyOffer.url; } return; }
      clearEphemeral();
      if (a === 'buy') { track('buy_started', { product: buyOffer && buyOffer.product }); say('me', 'Add to basket'); startBuy(); }
      else if (a === 'variant') { buyVariant = Number(arg) || 0; track('variant_picked', { product: buyOffer.product, option: buyOffer.variants[buyVariant].option }); say('me', buyOffer.variants[buyVariant].option || 'Standard'); askPlan(); }
      else if (a === 'plan') { say('me', act.textContent); buyNow(arg); }
      else if (a === 'basket') { window.location.href = '/cart'; }
      else if (a === 'checkout') { track('checkout_clicked', { product: buyOffer && buyOffer.product }); window.location.href = '/checkout'; }
      else if (a === 'ask') { send(arg || act.textContent); }
      return;
    }
    var pill = e.target.closest('.lls-sw-pill');
    if (pill) { var ptext = pill.textContent; var prow = pill.closest('.lls-sw-pills'); if (prow) prow.remove(); send(ptext); return; }
    var lb = e.target.closest('.lls-sw-livebtn');
    if (lb) { var off = lb.closest('.lls-sw-liveoffer'); if (off) off.remove(); startLive(''); return; }
    if (e.target.closest('.lls-sw-notyou')) {
      saveIdentity(null); state = { id: null, msgs: [], t: Date.now(), open: true, view: 'chat' }; save();
      msgs.innerHTML = ''; add('bot', greeting()); quick.hidden = false; heroGreeting(); updateWhoLine();
    }
  });
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : send(input.value); } });
  input.addEventListener('input', function () { input.style.height = 'auto'; input.style.height = Math.min(120, input.scrollHeight) + 'px'; });
  form.addEventListener('submit', function (e) { e.preventDefault(); send(input.value); });

  // ---------- Suggestion pills + add-to-basket offers ----------
  function clearEphemeral() {
    [].forEach.call(msgs.querySelectorAll('.lls-sw-pills'), function (n) { n.remove(); });
    state.pills = null; save();
  }
  // Remember whatever row is on screen, plus where the customer had got to in buying, so the
  // chat survives a page change. Clicking "See full details" navigates away and must come back
  // to the same point, not to a dead end.
  function say(who, text) { add(who, text); state.msgs.push({ who: who, text: text }); save(); }
  function rememberPills(type, items) {
    state.pills = { type: type, items: items };
    state.offer = buyOffer; state.offerVar = buyVariant;
    save();
  }
  function renderSuggestions(list) {
    clearEphemeral();
    var row = document.createElement('div');
    row.className = 'lls-sw-pills';
    row.innerHTML = list.map(function (t) { return '<button type="button" class="lls-sw-pill">' + esc(t) + '</button>'; }).join('');
    msgs.appendChild(row); msgs.scrollTop = msgs.scrollHeight;
    rememberPills('suggest', list);
  }
  function money(n) { return '\u00a3' + Number(n).toFixed(2); }
  function supplyLabel(n) { return n + '-Month Supply'; }

  // Buying happens as a conversation, not as a panel. The assistant recommends something and
  // offers to add it; the choices then arrive as ordinary pills, one question at a time, so it
  // reads like talking to someone rather than having a shop window pushed in your face.
  var buyOffer = null, buyVariant = 0;
  var cartCache = { at: 0, items: null };
  function refreshCart() {
    try {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        cartCache = { at: Date.now(), items: (c.items || []).slice(0, 12).map(function (i) {
          return { handle: i.handle, title: i.product_title, option: i.variant_title || '', qty: i.quantity,
            plan: i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.name : '', price: i.line_price / 100 };
        }) };
      }).catch(function () {});
    } catch (e) {}
  }
  refreshCart();
  setInterval(refreshCart, 30000);
  document.addEventListener('cart:refresh', refreshCart);

  // Fire-and-forget so it never delays or breaks the conversation. Without this we can read the
  // transcripts but cannot tell whether anyone actually buys, which makes the whole selling
  // feature impossible to judge.
  function track(event, extra) {
    try {
      var payload = { event: event, sessionId: state.id || undefined };
      if (extra) for (var k in extra) payload[k] = extra[k];
      fetch(cfg.endpoint.replace(/\/$/, '') + '/track', {
        method: 'POST', headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload), keepalive: true,
      }).catch(function () {});
    } catch (e) {}
  }

  function renderActions(items) {
    clearEphemeral();
    var row = document.createElement('div');
    row.className = 'lls-sw-pills';
    row.innerHTML = items.map(function (it) {
      return '<button type="button" class="lls-sw-pill lls-sw-act' + (it.primary ? ' is-primary' : '') +
        '" data-act="' + esc(it.act) + '" data-arg="' + esc(it.arg == null ? '' : String(it.arg)) + '">' + esc(it.label) + '</button>';
    }).join('');
    msgs.appendChild(row); msgs.scrollTop = msgs.scrollHeight;
    rememberPills('actions', items);
  }

  // Shown alongside the recommendation: buy it, or go and read the page. Whatever the assistant
  // suggested follows, trimmed so the row never becomes a wall of buttons.
  function offerIntro(o, suggestions) {
    if (!o || !o.variants || !o.variants.length || !o.inStock) return false;
    buyOffer = o; buyVariant = 0;
    for (var i = 0; i < o.variants.length; i++) { if (o.variants[i].inStock) { buyVariant = i; break; } }
    var acts;
    if (o.compact) {
      // Riding along under an answer: a way to buy, never a pitch. If it is already in their
      // basket the useful button is Checkout, not another Add to basket.
      var inBasket = (cartCache.items || []).some(function (i) { return i.title && o.product && i.title.toLowerCase() === String(o.product).toLowerCase(); });
      acts = inBasket ? [{ label: 'Checkout', act: 'checkout', primary: true }] : [{ label: 'Add to basket', act: 'buy', primary: true }];
      (suggestions || []).slice(0, 3).forEach(function (t) { acts.push({ label: t, act: 'ask', arg: t }); });
    } else {
      track('offer_shown', { product: o.product });
      acts = [{ label: 'Add to basket', act: 'buy', primary: true }, { label: 'See full details', act: 'details' }];
      (suggestions || []).slice(0, 2).forEach(function (t) { acts.push({ label: t, act: 'ask', arg: t }); });
    }
    renderActions(acts);
    return true;
  }

  // The lab results exactly as the product page shows them (custom.lab_reports), with the PDF.
  function labCard(r) {
    if (!r || !r.rows || !r.rows.length) return;
    var d = r.testDate ? new Date(r.testDate + 'T12:00:00Z') : null;
    var when = d && !isNaN(d) ? d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
    var el = document.createElement('div');
    el.className = 'lls-sw-lab';
    el.innerHTML =
      '<div class="lls-sw-lab-h">Lab results' + (r.batch ? ' · batch ' + esc(r.batch) : '') + '</div>' +
      '<div class="lls-sw-lab-sub">' + esc(String(r.lab || '').split(',')[0]) + (when ? ' · ' + esc(when) : '') + '</div>' +
      (r.claim && r.claim.value && r.measured && r.measured.value ?
        '<div class="lls-sw-lab-hero"><div><span>On the label</span><b>' + esc(r.claim.value) + '</b><small>' + esc(r.claim.desc || '') + '</small></div>' +
        '<div><span>Lab measured</span><b>' + esc(r.measured.value) + '</b><small>' + esc(r.measured.desc || '') + '</small></div></div>' : '') +
      (r.note ? '<p class="lls-sw-lab-note">' + esc(r.note) + '</p>' : '') +
      '<div class="lls-sw-lab-rows">' + r.rows.map(function (x) {
        return '<div class="lls-sw-lab-row"><span>' + esc(x.name) + '</span><span>' + esc(x.result) + '</span>' +
          (x.pill ? '<em>' + esc(x.pill) + '</em>' : '<i></i>') + '</div>';
      }).join('') + '</div>' +
      (r.pdf ? '<a class="lls-sw-lab-pdf" href="' + esc(r.pdf) + '" target="_blank" rel="noopener">View the full lab report (PDF)</a>' : '');
    msgs.appendChild(el);
    msgs.scrollTop = msgs.scrollHeight;
    track('lab_shown', { product: r.product });
  }

  function startBuy() {
    var o = buyOffer; if (!o) return;
    var inStock = o.variants.filter(function (v) { return v.inStock; });
    if (inStock.length > 1) {
      say('bot', 'Which one would you like?');
      renderActions(o.variants.map(function (v, i) {
        return v.inStock ? { label: v.option || 'Standard', act: 'variant', arg: i } : null;
      }).filter(Boolean));
      return;
    }
    askPlan();
  }

  function askPlan() {
    var o = buyOffer; if (!o) return;
    var v = o.variants[buyVariant], sub = o.subscription;
    var opts = [];
    if (sub && v.subFirst) {
      say('bot', 'Subscribing is the cheaper way: ' + sub.pctFirst + '% off your first delivery, then ' + sub.pctAfter +
        '% off every one after, free delivery, and you can skip or cancel any time. One tub every ' +
        (sub.months === 1 ? 'month' : sub.months + ' months') + ', so it turns up as you run out.');
      opts.push({ label: supplyLabel(sub.months) + ' \u00b7 ' + money(v.subFirst), act: 'plan', arg: sub.planId, primary: true });
      if (sub.pack && v.packPerTub) opts.push({ label: supplyLabel(sub.pack.months) + ' \u00b7 ' + money(v.packPerTub) + '/tub', act: 'plan', arg: sub.pack.planId });
    }
    opts.push({ label: 'Buy once \u00b7 ' + money(v.price), act: 'plan', arg: 'once' });
    renderActions(opts);
  }

  function buyNow(planArg) {
    var o = buyOffer; if (!o) return;
    var v = o.variants[buyVariant], sub = o.subscription;
    var planId = planArg === 'once' ? '' : planArg;
    var isPack = !!(sub && sub.pack && planArg === sub.pack.planId);
    clearEphemeral();
    // The three-tub plan does NOT multiply the quantity by itself. Sending 1 bought a single
    // tub at the three-tub price, which also kept the basket under the free-gift threshold.
    // Some products carry a cart rule that forces 3 regardless; asking for 3 is right either way.
    var item = { id: Number(v.variantId), quantity: isPack ? 3 : 1 };
    if (planId) item.selling_plan = Number(planId);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error('could not add');
        // Read the basket back and describe what is actually in it. Cart rules and gift
        // functions can change the line after we add it, and the customer must never be told
        // a number the checkout will contradict.
        // The free-gift line lands a moment after ours, so read the basket, and if the gift has
        // not appeared yet give it one more go before describing what is in there.
        var readCart = function () { return fetch('/cart.js').then(function (r) { return r.json(); }); };
        var hasGift = function (c) { return (c.items || []).some(function (it) { return it.line_price === 0; }); };
        // The Checkout button goes up the moment the add succeeds; waiting for the gift line to
        // settle first held it back ~8 seconds, long enough for people to go looking for the basket.
        renderActions([{ label: 'Checkout', act: 'checkout', primary: true }, { label: 'View basket', act: 'basket' }, { label: 'Keep looking', act: 'ask', arg: 'What else would go well with that?' }]);
        return new Promise(function (ok) { setTimeout(ok, 700); })
          .then(readCart)
          .then(function (c) { return hasGift(c) ? c : new Promise(function (ok) { setTimeout(ok, 1500); }).then(readCart); })
          .then(function (cart) {
          var mine = null;
          (cart.items || []).forEach(function (it) { if (String(it.variant_id) === String(v.variantId)) mine = it; });
          var what = o.product + (v.option ? ' (' + v.option + ')' : '');
          var qty = mine ? mine.quantity : (isPack ? 3 : 1);
          var lineTotal = mine ? mine.line_price / 100 : null;
          var line;
          if (!planId) line = 'Added ' + what + ' to your basket, ' + money(lineTotal == null ? v.price : lineTotal) + '.';
          else if (isPack) line = 'Added ' + what + ' to your basket: ' + qty + ' tubs together' +
            (lineTotal == null ? '' : ', ' + money(lineTotal)) + ', repeating every ' + sub.pack.months + ' months.';
          else line = 'Added ' + what + ' to your basket. ' + money(v.subFirst) + ' today, then ' + money(v.subAfter) + ' a delivery. Skip or cancel any time.';
          var gift = (cart.items || []).filter(function (it) { return it.line_price === 0 && String(it.variant_id) !== String(v.variantId); });
          if (gift.length) line += ' Your free ' + gift[0].product_title.replace(/\s*\(.*\)$/, '') + ' is in there too.';
          // Say it above the buttons, not below them.
          var actRow = msgs.querySelector('.lls-sw-pills:last-child');
          say('bot', line);
          if (actRow && actRow.parentNode === msgs) msgs.appendChild(actRow);
          track('added_to_cart', {
            product: o.product, option: v.option || '',
            plan: !planId ? 'one-time' : (isPack ? 'pack' : 'subscription'),
            value: lineTotal == null ? v.price : lineTotal,
          });
          return cart;
        });
      })
      .then(function () {
        msgs.scrollTop = msgs.scrollHeight;
        // Nudge the theme so the header count and drawer catch up without a reload.
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
        try { if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lls-support' }); } catch (e) {}
      })
      .catch(function () {
        add('bot', 'I could not add that to your basket from here. You can add it on the product page: ' + (o.url || 'lovelifesupplements.co.uk'), { note: true });
      });
  }

  // ---------- Live chat (presence-aware) ----------
  var agentsCache = { at: 0, anyOnline: false, agents: [] };
  var livePoll = null;
  function checkAgents(cb) {
    if (Date.now() - agentsCache.at < 45000) { cb(agentsCache); return; }
    fetch(cfg.endpoint.replace(/\/$/, '') + '/agents-online').then(function (r) { return r.json(); })
      .then(function (j) { agentsCache = { at: Date.now(), anyOnline: !!j.anyOnline, agents: j.agents || [] }; cb(agentsCache); })
      .catch(function () { cb({ anyOnline: false, agents: [] }); });
  }
  function setLiveHeader(on, who) {
    var st = root.querySelector('.lls-sw-status');
    if (st) st.innerHTML = on ? '<span class="lls-sw-dot"></span>Live with ' + esc(who || 'the team') : '<span class="lls-sw-dot"></span>Typically replies in a few minutes';
  }
  function addAgent(sender, text) {
    var el = document.createElement('div');
    el.className = 'lls-sw-msg lls-sw-bot lls-sw-agent';
    el.innerHTML = '<span class="lls-sw-agentname">' + esc(sender || 'Team') + '</span>' + render(text);
    msgs.appendChild(el); msgs.scrollTop = msgs.scrollHeight;
  }
  // Offered only after the assistant decides it needs a person, and only if someone is really online.
  function offerLiveIfOnline() {
    checkAgents(function (a) {
      if (!a.anyOnline || (state.live && state.live.on)) return;
      var who = (a.agents && a.agents[0] && a.agents[0].name) ? a.agents[0].name : 'Someone';
      var el = document.createElement('div');
      el.className = 'lls-sw-msg lls-sw-note lls-sw-liveoffer';
      el.innerHTML = esc(who) + ' is online now if you would rather not wait. <button type="button" class="lls-sw-livebtn">Chat with ' + esc(who) + '</button>';
      msgs.appendChild(el); msgs.scrollTop = msgs.scrollHeight;
    });
  }
  // Not solved in the chat: offer to carry on over WhatsApp, so the reply reaches their phone
  // instead of depending on this tab staying open. Once per chat.
  function offerWhatsApp() {
    if (state.waOffered) return;
    state.waOffered = true; save();
    var el = document.createElement('div');
    el.className = 'lls-sw-msg lls-sw-note lls-sw-waoffer';
    el.innerHTML = 'Want us to follow up with you on WhatsApp instead? Tap below and send the message that opens. The team will reply there, with this chat in front of them.' +
      '<a class="lls-sw-wabtn lls-sw-wa" data-where="handoff" href="https://wa.me/' + WA_NUM + '" target="_blank" rel="noopener">' + IC.wa + ' Follow up on WhatsApp</a>';
    msgs.appendChild(el); msgs.scrollTop = msgs.scrollHeight;
    track('wa_offered');
  }
  function humanFlow() {
    setView('chat');
    var probe = add('bot', 'One moment, checking if the team is available...', { note: true });
    checkAgents(function (a) { if (probe && probe.remove) probe.remove(); if (a.anyOnline) startLive(''); else send('I would like to speak to a person'); });
  }
  function startLive(initialMessage) {
    var meta = cfg.customer ? { email: cfg.customer.email, name: cfg.customer.name } : { email: (identity && identity.email) || state.email || '', name: (identity && identity.name) || state.name || '' };
    typing(true);
    fetch(cfg.endpoint.replace(/\/$/, '') + '/live/start', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ sessionId: state.id || undefined, message: initialMessage || '', meta: meta }) })
      .then(function (r) { return r.json(); })
      .then(function (b) {
        typing(false);
        if (b && b.live) {
          if (b.sessionId) state.id = b.sessionId;
          state.live = { on: true, convId: b.conversationId, afterId: 0 }; save();
          var who = (b.agents && b.agents[0] && b.agents[0].name) ? b.agents[0].name : 'the team';
          add('bot', 'You are connected to ' + who + '. Type your message below and they will reply here.', { note: true });
          setLiveHeader(true, who); quick.hidden = true; startPolling();
        } else { send('I would like to speak to a person'); }
      })
      .catch(function () { typing(false); send('I would like to speak to a person'); });
  }
  // Every website chat is visible to the team in Chatwoot. While a chat is recent, quietly check whether
  // someone has replied there; if they have, show it and switch this chat to them.
  var watchTimer = null;
  function startWatch() { stopWatch(); watchTick(true); }
  function stopWatch() { if (watchTimer) { clearTimeout(watchTimer); watchTimer = null; } }
  function watchTick(first) {
    watchTimer = null;
    if ((state.live && state.live.on) || !state.mirror || !state.id) return;
    if (Date.now() - state.mirror > 30 * 60 * 1000) return;              // 30 min after the last message
    var next = function () { watchTimer = setTimeout(watchTick, panel.hidden ? 15000 : 6000); };
    if (first || document.hidden) { next(); return; }
    fetch(cfg.endpoint.replace(/\/$/, '') + '/live/poll', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ sessionId: state.id, afterId: state.watchAfter || 0 }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || j.ended || j.status === 'resolved') { next(); return; }
        var got = j.agent || [];
        if (got.length) { goLive(got[0].sender, got, j.lastId); return; }
        if (j.lastId) { state.watchAfter = j.lastId; save(); }
        next();
      })
      .catch(next);
  }
  function goLive(who, firstMsgs, lastId) {
    stopWatch();
    try { clearEphemeral(); } catch (e) {}
    state.live = { on: true, afterId: lastId || state.watchAfter || 0 }; save();
    add('bot', 'You are now chatting with ' + (who || 'our team') + ' from Love Life Supplements. They will reply here.', { note: true });
    (firstMsgs || []).forEach(function (m) { addAgent(m.sender, m.text); state.msgs.push({ who: 'agent', text: m.text, sender: m.sender }); });
    save();
    if (firstMsgs && firstMsgs.length && panel.hidden) { badge.hidden = false; badge.textContent = String(firstMsgs.length); navBadge.hidden = false; }
    setLiveHeader(true, who); quick.hidden = true; startPolling();
  }
  function startPolling() { stopPolling(); if (!(state.live && state.live.on)) return; livePoll = setInterval(pollLive, 4000); pollLive(); }
  function stopPolling() { if (livePoll) { clearInterval(livePoll); livePoll = null; } }
  function pollLive() {
    if (!(state.live && state.live.on)) { stopPolling(); return; }
    fetch(cfg.endpoint.replace(/\/$/, '') + '/live/poll', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ sessionId: state.id, afterId: (state.live && state.live.afterId) || 0 }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j) return;
        if (j.ended || j.status === 'resolved') { endLive(); return; }
        var got = (j.agent || []);
        got.forEach(function (m) { addAgent(m.sender, m.text); state.msgs.push({ who: 'agent', text: m.text, sender: m.sender }); });
        if (j.lastId && state.live) state.live.afterId = j.lastId;
        if (got.length) { save(); if (panel.hidden) { badge.hidden = false; badge.textContent = String(got.length); navBadge.hidden = false; } }
      })
      .catch(function () {});
  }
  function endLive() { stopPolling(); if (state.live) state.live.on = false; save(); setLiveHeader(false); add('bot', state.mirror ? 'The team has closed this chat. You can keep asking here and the assistant will help.' : 'This chat has ended. Send a message any time and we will reply by email.', { note: true }); quick.hidden = false; }
  function sendLive(text) {
    busy = true; sendBtn.disabled = true; input.value = ''; input.style.height = 'auto'; quick.hidden = true;
    add('me', text); state.msgs.push({ who: 'me', text: text }); save();
    fetch(cfg.endpoint.replace(/\/$/, '') + '/live/send', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ sessionId: state.id, message: text }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.ended) endLive(); })
      .catch(function () {})
      .then(function () { busy = false; sendBtn.disabled = false; focusInput(typedLast); });
  }
  // On a phone, focusing the box opens the keyboard over half the screen and pushes the answer
  // out of sight (seen on an S23, 12 Oct). Only bring it back if they were typing.
  var TOUCH = false, typedLast = false;
  try { TOUCH = window.matchMedia('(hover: none) and (pointer: coarse)').matches; } catch (e) {}
  function focusInput(wasTyping) { if (!TOUCH || wasTyping) { try { input.focus(); } catch (e) {} } }

  function send(text, label) {
    text = String(text || '').trim();
    if (!text || busy) return;
    typedLast = document.activeElement === input;
    var shown = String(label || text).trim();
    if (view !== 'chat') setView('chat');
    clearEphemeral();
    if (state.live && state.live.on) return sendLive(text);
    busy = true; sendBtn.disabled = true; input.value = ''; input.style.height = 'auto'; quick.hidden = true;
    add('me', shown); state.msgs.push({ who: 'me', text: shown }); save();
    typing(true);
    var meta = cfg.customer ? { email: cfg.customer.email, name: cfg.customer.name, customerId: cfg.customer.id }
                            : { email: (identity && identity.email) || state.email || '', name: (identity && identity.name) || state.name || '' };
    if (identity && identity.token) meta.token = identity.token;
    meta.w = 3;   // widget version: tells the Worker this build shows a single buy button per answer
    // What is in their basket, so a suggestion can be about what they are actually buying.
    // Read at most every 30 seconds; a chat message must never wait on the cart.
    if (cartCache.items && Date.now() - cartCache.at < 30000) meta.cart = cartCache.items;
    var kx = klaviyoExchangeId(); if (kx) meta.kx = kx;
    if (LABS) meta.labs = true;
    var payload = { sessionId: state.id || undefined, message: text, page: location.href, meta: meta, stream: true };
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl && setTimeout(function () { ctrl.abort(); }, 60000);

    // The reply is streamed. A good answer takes a few seconds of real thinking, so rather than
    // hide that behind a silent spinner we show what it is doing, then the words as they land.
    var bubble = null, streamed = '';
    function onDelta(t) {
      if (!bubble) { typing(false); bubble = add('bot', ''); }
      streamed += t;
      bubble.innerHTML = render(streamed);
      msgs.scrollTop = msgs.scrollHeight;
    }
    function onStatus(t) { if (!bubble) typingLabel(t); }

    function finish(b) {
      if (b.sessionId) state.id = b.sessionId;
      // Someone on the team has taken this chat over: their replies come here, the assistant steps back.
      if (b.takeover) { goLive(b.agent); return; }
      var learned = b.customer || b.known;
      if (learned && learned.email) { state.email = learned.email; if (learned.name) state.name = learned.name; heroGreeting(); updateWhoLine(); }
      if (b.identity && b.identity.token) { saveIdentity({ token: b.identity.token, email: b.identity.email, name: b.identity.name || state.name || '', exp: Date.now() + 90 * 24 * 3600 * 1000 }); heroGreeting(); updateWhoLine(); }
      var finalText = b.reply || streamed;
      if (bubble) bubble.innerHTML = render(finalText); else add('bot', finalText);
      state.msgs.push({ who: 'bot', text: finalText }); save();
      // An offer turns the pill row into the start of a buy conversation; otherwise the
      // assistant's own suggestions stand on their own.
      if (b.lab) labCard(b.lab);
      var shown = LABS && b.offer ? offerIntro(b.offer, b.suggestions) : false;
      if (!shown && LABS && b.checkout) {
        renderActions([{ label: 'Checkout', act: 'checkout', primary: true }, { label: 'View basket', act: 'basket' }]
          .concat((b.suggestions || []).slice(0, 2).map(function (t) { return { label: t, act: 'ask', arg: t }; })));
        shown = true;
      }
      if (!shown && LABS && b.suggestions && b.suggestions.length) renderSuggestions(b.suggestions);
      if (b.handoff) { onHandoff(b.handoff); offerLiveIfOnline(); offerWhatsApp(); }
      if (b.mirror) { state.mirror = Date.now(); save(); startWatch(); }
    }

    fetch(cfg.endpoint.replace(/\/$/, '') + '/chat', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        // Older browsers, or any non-stream response, fall back to reading it in one piece.
        if (!r.ok || !r.body || !r.body.getReader || !/event-stream/.test(r.headers.get('content-type') || '')) {
          return r.json().then(function (j) { typing(false); if (!r.ok) { fail(j && j.error); return; } finish(j); });
        }
        var reader = r.body.getReader(), dec = new TextDecoder(), buf = '', failed = null;
        return (function pump() {
          return reader.read().then(function (res) {
            if (res.value) buf += dec.decode(res.value, { stream: true });
            var i;
            while ((i = buf.indexOf('\n\n')) >= 0) {
              var line = buf.slice(0, i).replace(/^data: /, ''); buf = buf.slice(i + 2);
              if (!line.trim()) continue;
              var ev; try { ev = JSON.parse(line); } catch (e) { continue; }
              if (ev.type === 'text') onDelta(ev.text);
              else if (ev.type === 'status') onStatus(ev.text);
              else if (ev.type === 'error') failed = ev.error;
              else if (ev.type === 'done') { typing(false); finish(ev); }
            }
            if (res.done) { typing(false); if (failed) fail(failed); else if (!bubble && !streamed) fail(); return; }
            return pump();
          });
        })();
      })
      .catch(function () { typing(false); if (!streamed) fail(); })
      .then(function () { if (timer) clearTimeout(timer); busy = false; sendBtn.disabled = false; focusInput(typedLast); });
  }

  function fail(msg) { add('bot', msg || ('The assistant is not available right now. Email ' + cfg.supportEmail + ' and a person will reply, or try again in a minute.'), { note: true }); }

  function onHandoff(h) {
    if (h.delivered) return;
    var api = window.tidioChatApi;
    if (cfg.tidioBridge && api && api.messageFromVisitor) {
      try {
        if (api.show) api.show();
        if (h.email) api.setVisitorData({ email: h.email, name: h.name || '' });
        if (api.addVisitorTags) api.addVisitorTags(['bot-handoff']);
        api.messageFromVisitor('Handoff from the LLS assistant (' + (h.reason || 'needs a person') + ')\n' + (h.email ? 'Customer email: ' + h.email + '\n' : '') + '\n' + (h.transcript || h.summary || ''));
        setTimeout(function () { try { api.close(); if (cfg.hideTidio && api.hide) api.hide(); } catch (e) {} }, 1500);
        return;
      } catch (e) {}
    }
    add('bot', 'If you do not hear from us, email ' + cfg.supportEmail + ' and mention this chat.', { note: true });
  }

  // Warm start
  hideTidio();
  heroGreeting(); updateWhoLine();
  if (state.open) openPanel();
  if (state.live && state.live.on) { setLiveHeader(true, ''); startPolling(); }
  else if (state.mirror) startWatch();
  // Opened from the subscription cancel flow ("Chat now" button, ?lls_chat=<reason>): open the chat
  // and start it with the context already said, so nobody has to explain why they are here.
  try {
    var chatFrom = /[?&]lls_chat=([a-z_]+)/.exec(location.search);
    if (chatFrom) {
      var why = { didnt_work: 'it did not work for me', delivery: 'there was a problem with my delivery or order' }[chatFrom[1]];
      try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])lls_chat=[a-z_]+&?/, '$1').replace(/[?&]$/, '') + location.hash); } catch (e) {}
      openPanel();
      setTimeout(function () { send('I was about to cancel my subscription' + (why ? ' because ' + why : '') + ', and chose to chat instead. Can you help?', 'I was about to cancel. Can you help?'); }, 700);
    }
  } catch (e) {}
  // Logged in: remember this customer on this browser for 90 days, so they are still recognised when logged out later.
  if (cfg.customer && cfg.customer.email && cfg.customer.id && !(identity && identity.token && identity.email === String(cfg.customer.email).toLowerCase())) {
    try {
      fetch(cfg.endpoint.replace(/\/$/, '') + '/identify', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ email: cfg.customer.email, customerId: cfg.customer.id }) })
        .then(function (r) { return r.json(); })
        .then(function (b) { if (b && b.ok && b.identity && b.identity.token) { saveIdentity({ token: b.identity.token, email: b.identity.email, name: b.identity.name || cfg.customer.name || '', exp: Date.now() + 90 * 24 * 3600 * 1000 }); heroGreeting(); updateWhoLine(); } })
        .catch(function () {});
    } catch (e) {}
  }

  // ---- Keep clear of the page's own bottom bar ----------------------------------------
  // The product page pins an add-to-cart bar to the bottom on scroll, and the launcher sat on
  // top of the price and part of the button. Detected by shape rather than by class name, so a
  // future bar on another template is handled without another fix.
  var liftNow = 0;
  function bottomBarHeight() {
    var best = 0;
    var els = document.querySelectorAll('div,section,form,aside,nav');
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (root.contains(e)) continue;
      var cs = getComputedStyle(e);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') continue;
      var r = e.getBoundingClientRect();
      // A bar, not a full-screen overlay and not a stray pixel: wide, short, sitting on the floor.
      if (r.width < window.innerWidth * 0.6) continue;
      if (r.height < 36 || r.height > 160) continue;
      if (Math.abs(r.bottom - window.innerHeight) > 4) continue;
      // The Shopify preview bar is staff-only scaffolding, not part of the shop.
      if (/PBar/.test(e.id || '') || (e.parentElement && /PBar/.test(e.parentElement.id || ''))) continue;
      // It must actually be PAINTED there. A closed cart drawer keeps a sticky footer whose
      // rectangle still lands on the floor of the screen, and lifting for that would push the
      // launcher up the page permanently for no reason.
      // Read the whole stack at that point, not just the top element: the page carries a
      // transparent full-screen layer from the email-capture app that wins elementFromPoint
      // while letting clicks straight through, and it would hide every real bar from a
      // single-element test.
      var stack = document.elementsFromPoint
        ? document.elementsFromPoint(Math.round(r.left + r.width / 2), Math.round(r.top + r.height / 2))
        : [document.elementFromPoint(Math.round(r.left + r.width / 2), Math.round(r.top + r.height / 2))];
      var painted = false;
      for (var k = 0; k < stack.length; k++) { if (stack[k] === e || e.contains(stack[k])) { painted = true; break; } }
      if (!painted) continue;
      if (r.height > best) best = r.height;
    }
    return Math.round(best);
  }
  function applyLift() {
    var h = bottomBarHeight();
    if (h === liftNow) return;
    liftNow = h;
    root.style.setProperty('--lls-lift', h ? h + 'px' : '0px');
  }
  var liftTimer = null;
  function scheduleLift() { if (liftTimer) return; liftTimer = setTimeout(function () { liftTimer = null; applyLift(); }, 120); }
  window.addEventListener('scroll', scheduleLift, { passive: true });
  window.addEventListener('resize', scheduleLift);
  setInterval(applyLift, 1500);   // bars also appear without a scroll (variant changes, lazy blocks)
  applyLift();

  // ---- Opening nudge -------------------------------------------------------------------
  // Deliberately restrained: one short line, once a day, gone for good if dismissed, and never
  // on top of another popup. A nag would cost more goodwill than the chats are worth.
  // OFF everywhere since 27 Oct 2026 (Ben): in 10 days ~610 shows/day, ~7 taps, ~47 closes. ?lls_nudge=1 still shows it for testing.
  var NUDGE_OFF = true;
  var NUDGE_KEY = 'lls_support_nudge', nudgeTries = 0;
  // ?lls_nudge=1 forces it: ignores the once-a-day rule and appears almost straight away.
  // For checking the wording without having to clear site data between looks.
  var NUDGE_FORCE = false;
  try {
    if (/[?&]lls_nudge=1/.test(location.search)) sessionStorage.setItem('lls_nudge_force', '1');
    if (/[?&]lls_nudge=0/.test(location.search)) sessionStorage.removeItem('lls_nudge_force');
    NUDGE_FORCE = sessionStorage.getItem('lls_nudge_force') === '1';
  } catch (e) { NUDGE_FORCE = /[?&]lls_nudge=1/.test(location.search); }
  function nudgeState() {
    try { return JSON.parse(localStorage.getItem(NUDGE_KEY) || 'null') || {}; } catch (e) { return {}; }
  }
  function nudgeSeen(v) { try { localStorage.setItem(NUDGE_KEY, JSON.stringify(v)); } catch (e) {} }

  function nudgeText() {
    var path = location.pathname;
    if (/\/products\//.test(path)) {
      var t = (document.querySelector('h1') || {}).textContent || '';
      t = t.replace(/\s+/g, ' ').trim().replace(/\s*\(.*\)$/, '');
      return t ? 'Any questions about ' + (t.length > 34 ? 'this one' : t) + '?' : 'Any questions about this one?';
    }
    if (/\/(cart|checkout)/.test(path)) return 'Need a hand before you order?';
    if (/loop_subscriptions|\/account/.test(path)) return 'Need to change a delivery? I can do that here.';
    if (/\/pages\/(contact|faq|delivery|returns|shipping)/.test(path)) return 'Want an answer now instead of waiting on email?';
    if (/\/collections\//.test(path)) return 'Not sure which one suits you? Ask me.';
    return knownName() ? 'Hi ' + knownName() + ', need a hand with anything?' : 'Need a hand? I can check orders and subscriptions too.';
  }

  // Articles and product pages have their own opener: one line about what that page is about,
  // plus three questions to tap (kb/build-nudges.mjs). The generic line was shown 669 times in a
  // day and opened once; 61% of those were on articles read by people with one specific question.
  var nudgePath = location.pathname.toLowerCase().replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/, '').replace(/\/+$/, '');
  var nudgeKind = /^\/blogs\/[^\/]+\/[^\/]+$/.test(nudgePath) ? 'article' : /^\/products\//.test(nudgePath) ? 'product' : 'other';
  var nudgeData = nudgeKind === 'other' ? null : undefined;       // undefined = still loading
  if (NUDGE_OFF && !NUDGE_FORCE) nudgeData = null;
  if (nudgeData === undefined) {
    try {
      fetch(cfg.endpoint.replace(/\/$/, '') + '/nudge?p=' + encodeURIComponent(nudgePath))
        .then(function (r) { return r.json(); })
        .then(function (d) { nudgeData = (d && d.line && d.chips && d.chips.length) ? d : null; })
        .catch(function () { nudgeData = null; });
    } catch (e) { nudgeData = null; }
  }

  function coveredByPopup() {
    try {
      for (var e = document.elementFromPoint(window.innerWidth / 2, window.innerHeight / 2); e; e = e.parentElement) {
        if (root.contains(e)) return false;
        var cs2 = getComputedStyle(e);
        if (cs2.position === 'fixed') {
          var rr = e.getBoundingClientRect();
          if (rr.width > window.innerWidth * 0.5 && rr.height > window.innerHeight * 0.35) return true;
        }
      }
    } catch (err) {}
    return false;
  }

  function showNudge() {
    if (NUDGE_OFF && !NUDGE_FORCE) return;
    if (!panel.hidden || state.open) return;                     // already talking
    if (!NUDGE_FORCE) {
      if (state.msgs.length) return;                             // mid-conversation
      var st = nudgeState();
      if (st.off) return;                                        // dismissed for good
      if (st.day === new Date().toDateString()) return;          // once a day is plenty
    }
    if (document.querySelector('.lls-sw-nudge')) return;
    if (nudgeData === undefined && nudgeTries++ < 8) { setTimeout(showNudge, 1000); return; }
    // Never stack on top of someone else's popup (the email capture takes the screen early on).
    // Test what is actually PAINTED at the middle of the screen: the page carries several
    // always-present full-size overlay containers that are invisible, and asking whether one
    // merely exists meant the nudge deferred itself forever.
    if (coveredByPopup()) { if (nudgeTries++ < 40) setTimeout(showNudge, 3000); return; }

    var d = nudgeData;
    var el = document.createElement('div');
    el.className = 'lls-sw-nudge' + (d ? ' has-chips' : '');
    el.innerHTML = '<button type="button" class="lls-sw-nudge-x" aria-label="No thanks">&times;</button>' +
      '<span class="lls-sw-nudge-t">' + esc(d ? d.line : nudgeText()) + '</span>' +
      (d ? '<span class="lls-sw-nudge-chips">' + d.chips.slice(0, 3).map(function (c) {
        return '<button type="button" class="lls-sw-nudge-chip">' + esc(c) + '</button>';
      }).join('') + '</span>' : '');
    root.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    if (!NUDGE_FORCE) nudgeSeen({ day: new Date().toDateString() });
    track('nudge_shown', { product: location.pathname.slice(0, 60), option: d ? 'page' : 'generic' });

    el.addEventListener('click', function (e) {
      if (e.target.closest('.lls-sw-nudge-x')) {
        nudgeSeen({ off: true });                                 // asked to stop, so stop
        track('nudge_dismissed', { product: location.pathname.slice(0, 60) });
        el.remove();
        return;
      }
      var chip = e.target.closest('.lls-sw-nudge-chip');
      el.remove();
      openPanel();
      if (chip) {
        track('nudge_chip', { product: location.pathname.slice(0, 60), option: chip.textContent.slice(0, 40) });
        send(chip.textContent);
      } else {
        track('nudge_opened', { product: location.pathname.slice(0, 60) });
        setView('chat');
      }
    });
    // A popup that opens after the nudge (the email offer usually does) must not end up with the
    // nudge sitting on top of it (seen 12 Oct). Step aside while it is up, come back after.
    var popupWatch = setInterval(function () {
      if (!el.parentNode) { clearInterval(popupWatch); return; }
      el.style.visibility = coveredByPopup() ? 'hidden' : '';
    }, 800);
    // Fades out on its own so it never becomes furniture, but not while someone is reading it.
    var life = d ? 30000 : 18000, fade;
    function arm() { fade = setTimeout(function () { if (el.parentNode) { el.classList.remove('is-in'); setTimeout(function () { el.remove(); }, 400); } }, life); }
    el.addEventListener('mouseenter', function () { clearTimeout(fade); });
    el.addEventListener('mouseleave', function () { clearTimeout(fade); life = 8000; arm(); });
    arm();
    // On a phone it sat over the page while people scrolled on (S23, 18 Oct): covered the FBT
    // add button and review text. Once they scroll on past it, it goes.
    if (window.matchMedia('(max-width: 640px)').matches) {
      var y0 = window.scrollY;
      var onMove = function () {
        if (!el.parentNode) { window.removeEventListener('scroll', onMove); return; }
        if (Math.abs(window.scrollY - y0) > window.innerHeight * 0.6) {
          window.removeEventListener('scroll', onMove);
          clearTimeout(fade);
          el.classList.remove('is-in');
          setTimeout(function () { el.remove(); }, 400);
        }
      };
      window.addEventListener('scroll', onMove, { passive: true });
    }
  }

  // When to show it. An article reader is offered help once they are into the piece (half way
  // down, or a minute in), not before they have read a line. A product page after a short look.
  // Everything else keeps the old 9 seconds.
  (function () {
    if (NUDGE_FORCE) { setTimeout(showNudge, 1200); return; }
    if (nudgeKind === 'other') { setTimeout(showNudge, 9000); return; }
    var start = Date.now(), fired = false;
    var minMs = nudgeKind === 'article' ? 10000 : 8000, maxMs = nudgeKind === 'article' ? 60000 : 15000;
    var depth = nudgeKind === 'article' ? 0.5 : 0.4;
    function fire() { if (fired) return; fired = true; window.removeEventListener('scroll', onScroll); showNudge(); }
    function onScroll() {
      if (fired || Date.now() - start < minMs) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= depth) fire();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(onScroll, minMs);
    setTimeout(fire, maxMs);
  })();

})();
